export const replaceAll = (str, de, para) => {
    var pos = str.indexOf(de);
    while (pos > -1) {
        str = str.replace(de, para);
        pos = str.indexOf(de);
    }
    return (str);
}

export const lpad = (target, padString, length) => {
    target = target.toString();
    while (target.length < length)
        target = padString + target;
    return target;
}

export const capitalize = (str) => {
    if (str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    } else {
        return '';
    }
};

export const getFirstAndLastName = (fullName) => {
    if(!fullName){
        return ""
    }
    let nameArray = fullName.split(" ");
    let name = (nameArray.length > 1) ? (nameArray[0] + " " + nameArray[nameArray.length -1]) : nameArray[0];
    return name;
}

export const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
};

export const sanitize = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
}

export const sanitizeWithoutTrim = (str) => {
  str = str.normalize("NFD").replace(/([\u0300-\u036f])/g, '').toUpperCase();

  if (/^[a-zA-Z0-9\b\s]+$/.test(str) || /[^\w-]\s+/g.test(str)) {
    return str.replace(/[^\w-]\s+/g, '');
  }

  return str.substr(0, str.length - 1);
}

export const sanitizeFullString = (str) => {
  str = str.normalize("NFD").replace(/([\u0300-\u036f])/g, '').toUpperCase();

  return str.replace(/[^a-zA-Z0-9 ]/g, ''); // Altere replaceAll para replace
}

export const isNumeric = (str) => {
  if (typeof str != "string") return false // we only process strings!
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
         !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
};

export const moveElementInsideArray = (arr, fromIndex, toIndex) => {
  let element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};
